import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { PushNotificationsService } from 'src/app/all-modules/shared/services/push-notifications.service';
import { DATE_FORMAT_CONSTATNS, MESSAGE_CATEGORY_CONSTATNS, MESSAGE_CONSTATNS, MODULE_CONSTANTS, ROLE_CONSTANTS } from '../../constants/constant';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { JobLaborPlanningService } from 'src/app/all-modules/job-labor-planning/service/job-labor-planning.service';
import { SpinnerService } from '../../services/spinner.service';
import { CommonToastService } from '../../services/common-toast.service';
import { billingWeekDataForCMDashboard, cityListForJobPlanning, cityListForJobPlanningWithDate, dailyReportDataForCMDashboard, overRunJobDashboardDataViewModel, payrollWeeksDataForCMDashboard, todaysCMDashboardInfo } from 'src/app/all-modules/job-labor-planning/models/job-labor-planning.model';
import { FormControl } from '@angular/forms';
import moment from 'moment';
import { cmPayrollCorrectionRequestViewModel, importantJobUpdatesInfo, importantJobUpdateSOViewModel } from 'src/app/all-modules/job-labor-planning/models/job-payroll-entry.model';
import { ApiResponse } from '../../common-model/common.model';

@Component({
  selector: 'app-dashboard-cm',
  templateUrl: './dashboard-cm.component.html',
  styleUrls: ['./dashboard-cm.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DashboardCMComponent implements OnInit {
  STRINGIFY_DROPDOWN_DISPLAY_CITY = (item: cityListForJobPlanning) => `${item.cityNameOriginal}`;
  readonly selectedCityValue = new FormControl();
  activeJobOverBudget = 0;
  overRunJobCount!: overRunJobDashboardDataViewModel;
  todaysCMDashboardInfo!: todaysCMDashboardInfo;
  payrollWeeksData!: payrollWeeksDataForCMDashboard;
  billingEntryDataForDashboard!: billingWeekDataForCMDashboard;
  dailyReportData!: dailyReportDataForCMDashboard;
  cityListForJobPlanning: cityListForJobPlanning[] = [];
  isFirstTime = true;
  todaysDate: string = "";
  isLoadingImportantJobDialog = false;
  isOpenImportantJobDialog = false;
  importantJobUpdateInfo!: importantJobUpdatesInfo;
  selectedNoOfJobList: importantJobUpdateSOViewModel[] = [];
  cmPayrollCorrectionRequestApprovedList: cmPayrollCorrectionRequestViewModel[] = [];
  isOpenPayrollCorrectioknReqApprovedDialog = false;
  isLoadingPayrollCorrectioknReqApprovedDialog = false;
  DAY_NAME_MONTH_DAY_YEAR = DATE_FORMAT_CONSTATNS.DAY_NAME_MONTH_DAY_YEAR;
  DAY_NAME_MONTH_DAY_YEAR_AM_PM = DATE_FORMAT_CONSTATNS.DAY_NAME_MONTH_DAY_YEAR_AM_PM;
  todayCardLoading = false;
  thisWeekPayrollCardLoading = false;
  dailyReportCardLoading = false;
  billingEntryCardLoading = false;
  jobOverrunCardLoading = false;
  importantJobCardLoading = false;
  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    private jobLaborService: JobLaborPlanningService,
    private commonService: CommonService,
    private spinnerService: SpinnerService,
    private commonToastService: CommonToastService
  ) {
    this.commonService.navigateToDashboardByRoleKey();
  }
  ngOnInit() {
    //DP-64 for this point we have added thisWeekPayrollCardLoading, dailyReportCardLoading, billingEntryCardLoading, jobOverrunCardLoading, importantJobCardLoading

    this.getCityListForJobPlanning();
    this.selectedCityValue.valueChanges.subscribe(value => {
      if (!this.isFirstTime) {
        if (this.commonService.isNotNULLEmptyUndefind(value)) {
          this.refreshDashboardData();
        }
      }
    });
  }
  // getBillingEntryReportAccess() {
  //   if(localStorage.getItem('roleKey') === ROLE_CONSTANTS.ACCOUNTING ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.ESTIMATOR)  {
  //    return true;
  //   }else {
  //     return false;
  //   }
  // }
  closeImportantJobDialog() {
    this.isOpenImportantJobDialog = false;
  }
  openImportantJobDialog(item: importantJobUpdateSOViewModel[]) {
    //if(item.length > 0) {
    this.isOpenImportantJobDialog = true;
    item.sort((n1, n2) => {
      if (n1.showName > n2.showName) {
        return 1;
      }
      if (n1.showName < n2.showName) {
        return -1;
      }
      return 0;
    });
    this.selectedNoOfJobList = item;
    //}
  }
  refreshDashboardData() {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 2000);
    this.getOverRunJobData();
    this.getTodayCardDashbaordData();
    this.getPayrollEntryCurrentWeekData();
    this.getDailyReportDataForCMDashboard();
    this.getBillingEntryCurrentWeekData();
    this.getImportantJobUpdates();
  }

  goToCalenderView() {
    let url = "job-planning/calendar-view";
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }
  gotToJobOverOnUnderBudget(statusKey: string) {
    let url = "job-planning/job-budget/" + statusKey + "/" + this.selectedCityValue.value.cityId;
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }
  goToLaborCheckIn() {
    let url = "job-planning/check-in";
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }
  goToDailyActivity(isYesterday: boolean, dailyStatusKey: string) {
    let url = "job-planning/daily-activity";
    if (this.selectedCityValue.value.cityId !== "All") {
      url = "job-planning/daily-activity?cityid=" + this.selectedCityValue.value.cityId;
      if (isYesterday) {
        url = "job-planning/daily-activity?isyest=true&cityid=" + this.selectedCityValue.value.cityId;
      }
      if (dailyStatusKey === "DUE") {
        url = "job-planning/daily-activity?isdue=true&cityid=" + this.selectedCityValue.value.cityId;
      }
      if (dailyStatusKey === "SUBM") {
        url = "job-planning/daily-activity?issubmitted=true&cityid=" + this.selectedCityValue.value.cityId;
      }
    } else {
      if (isYesterday) {
        url = "job-planning/daily-activity?isyest=true&cityid=" + this.selectedCityValue.value.cityId;
      }
      if (dailyStatusKey === "DUE") {
        url = "job-planning/daily-activity?isdue=true&cityid=" + this.selectedCityValue.value.cityId;
      }
      if (dailyStatusKey === "SUBM") {
        url = "job-planning/daily-activity?issubmitted=true&cityid=" + this.selectedCityValue.value.cityId;
      }
    }
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }
  goToPayrollEntry(key: string) {
    if (key === "NO_FILTER") {
      let url = "job-planning/payroll-entry";
      if (this.selectedCityValue.value.cityId !== "All") {
        url = "job-planning/payroll-entry?cityid=" + this.selectedCityValue.value.cityId;
      }
      this.router.navigate([]).then(result => { window.open(url, '_blank'); });
    } else {
      let url = "job-planning/payroll-entry?key=" + key;
      if (this.selectedCityValue.value.cityId !== "All") {
        url = "job-planning/payroll-entry?key=" + key + "&" + "cityid=" + this.selectedCityValue.value.cityId;
      }
      this.router.navigate([]).then(result => { window.open(url, '_blank'); });
    }
  }
  goToPayrollEntryReport() {
    let url = "job-planning/payroll-entry-report";
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }
  goToPayrollEntrySnapshot() {
    let url = "job-planning/payroll-entry-snapshot";
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }
  goToBillingEntry() {
    let url = "job-planning/billing-entry";
    if (this.selectedCityValue.value.cityId !== "All") {
      url = "job-planning/billing-entry?cityid=" + this.selectedCityValue.value.cityId;
    }
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }
  goToBillingEntryReport() {
    let url = "job-planning/billing-entry-report";
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }
  getBillingEntryReportAccess() {
    let count = this.commonService.getModuleAccess().filter(r => r.moduleKey === MODULE_CONSTANTS.BILLING_ENTRY_REPORT).length;
    if (count > 0) {
      return true;
    }
    return false;
  }
  getPayrollEntryReportAccess() {
    let count = this.commonService.getModuleAccess().filter(r => r.moduleKey === MODULE_CONSTANTS.PAYROLL_ENTRY_REPORT).length;
    if (count > 0) {
      return true;
    }
    return false;
  }
  getPayrollEntrySnapshotAccess() {
    let count = this.commonService.getModuleAccess().filter(r => r.moduleKey === MODULE_CONSTANTS.PAYROLL_ENTRY_SNAPSHOT).length;
    if (count > 0) {
      return true;
    }
    return false;
  }
  getBillingEntryAddUpdateAccess() {
    let count = this.commonService.getModuleAccess().filter(r => r.moduleKey === MODULE_CONSTANTS.BILLING_ENTRY_ADD_UPDATE).length;
    if (count > 0) {
      return true;
    }
    return false;
  }
  getPayrollEntryAddUpdateAccess() {
    let count = this.commonService.getModuleAccess().filter(r => r.moduleKey === MODULE_CONSTANTS.PAYROLL_ENTRY_ADD_UPDATE).length;
    if (count > 0) {
      return true;
    }
    return false;
  }
  getDailyActivityAccess() {
    let count = this.commonService.getModuleAccess().filter(r => r.moduleKey === MODULE_CONSTANTS.DAILY_ACTIVITY).length;
    if (count > 0) {
      return true;
    }
    return false;
  }
  getJobPlanningAccess() {
    let count = this.commonService.getModuleAccess().filter(r => r.moduleKey === MODULE_CONSTANTS.JOB_LABOR_PLANNING).length;
    if (count > 0) {
      return true;
    }
    return false;
  }
  getOverRunJobData() {
    this.jobOverrunCardLoading = true;
    this.overRunJobCount = {} as overRunJobDashboardDataViewModel;
    this.jobLaborService.getOverRunJobDataForDashboard(this.selectedCityValue.value.cityId).subscribe({
      next: (response: overRunJobDashboardDataViewModel) => {
        this.overRunJobCount = response;
      },
      complete: () => {
        setTimeout(() => {
          this.jobOverrunCardLoading = false;
          this.cdr.markForCheck();
        });
      },
      error: (error) => {
        this.jobOverrunCardLoading = false;
        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.JOB_PLANNING, error?.message);
        }
      }
    });
  }
  getIsNotComplted(dailyReportData: dailyReportDataForCMDashboard) {
    if (this.commonService.isNotNULLEmptyUndefind(dailyReportData)) {
      return (dailyReportData.todayDueCount > 0 && dailyReportData.yesterdayDueCount > 0) ? true : false
    }
    return false;
  }
  getTodayCardDashbaordData() {
    this.todayCardLoading = true;
    this.todaysCMDashboardInfo = {} as todaysCMDashboardInfo;
    this.jobLaborService.getTodayCardDashbaordData(this.selectedCityValue.value.cityId).subscribe({
      next: (response: todaysCMDashboardInfo) => {
        this.todaysCMDashboardInfo = response;
      },
      complete: () => {
        setTimeout(() => {
          this.todayCardLoading = false;
          this.cdr.markForCheck();
        });
      },
      error: (error) => {
        this.todayCardLoading = false;
        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.JOB_PLANNING, error?.message);
        }
      }
    });
  }
  getPayrollEntryCurrentWeekData() {
    this.thisWeekPayrollCardLoading = true;
    this.payrollWeeksData = {} as payrollWeeksDataForCMDashboard;
    this.jobLaborService.getPayrollEntryCurrentWeekData(this.selectedCityValue.value.cityId).subscribe({
      next: (response: payrollWeeksDataForCMDashboard) => {
        this.payrollWeeksData = response;
      },
      complete: () => {
        setTimeout(() => {
          this.thisWeekPayrollCardLoading = false;
          this.cdr.markForCheck();
        });
      },
      error: (error) => {
        this.thisWeekPayrollCardLoading = false;

        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.JOB_PLANNING, error?.message);
        }
      }
    });
  }
  getBillingEntryCurrentWeekData() {
    this.billingEntryCardLoading = true;
    this.billingEntryDataForDashboard = {} as billingWeekDataForCMDashboard;
    this.jobLaborService.getBillingEntryCurrentWeekData(this.selectedCityValue.value.cityId).subscribe({
      next: (response: billingWeekDataForCMDashboard) => {
        this.billingEntryDataForDashboard = response;
      },
      complete: () => {
        setTimeout(() => {
          this.billingEntryCardLoading = false;
          this.cdr.markForCheck();
        });
      },
      error: (error) => {
        this.billingEntryCardLoading = false;

        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.JOB_PLANNING, error?.message);
        }
      }
    });
  }
  getDailyReportDataForCMDashboard() {
    this.dailyReportCardLoading = true;
    this.dailyReportData = {} as dailyReportDataForCMDashboard;
    this.jobLaborService.getDailyReportDataForCMDashboard(this.selectedCityValue.value.cityId).subscribe({
      next: (response: dailyReportDataForCMDashboard) => {
        this.dailyReportData = response;
      },
      complete: () => {
        setTimeout(() => {
          this.dailyReportCardLoading = false;
          this.cdr.markForCheck();
        });
      },
      error: (error) => {
        this.dailyReportCardLoading = false;
        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.JOB_PLANNING, error?.message);
        }
      }
    });
  }
  openPayrollCorrectionReqApprovedDialog() {
    this.cmPayrollCorrectionRequestApprovedList = [];
    this.isOpenPayrollCorrectioknReqApprovedDialog = true;
    this.getLastWeekPayrollCorrectionApprovedDetails();
  }
  closePayrollCorrectionReqApprovedDialog() {
    this.isOpenPayrollCorrectioknReqApprovedDialog = false;
    this.isLoadingPayrollCorrectioknReqApprovedDialog = false;
  }
  getLastWeekPayrollCorrectionApprovedDetails() {
    if (this.selectedCityValue.value.cityId === "All") {
      this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.WARNING, MESSAGE_CATEGORY_CONSTATNS.JOB_PLANNING, MESSAGE_CONSTATNS.SELECT_CITY);
      return;
    }
    this.isLoadingPayrollCorrectioknReqApprovedDialog = true;
    this.cmPayrollCorrectionRequestApprovedList = [];
    this.jobLaborService.getPayrollCorrectionLastWeek(this.selectedCityValue.value.cityId).subscribe({
      next: (response: cmPayrollCorrectionRequestViewModel[]) => {
        this.cmPayrollCorrectionRequestApprovedList = response;
      },
      complete: () => {
        setTimeout(() => {
          this.isLoadingPayrollCorrectioknReqApprovedDialog = false;
          this.cdr.markForCheck();
        });
      },
      error: (error) => {
        this.isLoadingPayrollCorrectioknReqApprovedDialog = false;
        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.JOB_PLANNING, error?.message);
        }
      }
    });
  }
  getCityListForJobPlanning() {
    this.cityListForJobPlanning = [];
    let objAll: cityListForJobPlanning = {
      cityId: "All",
      cityName: "All",
      isDefaultCity: false,
      baseCityId: "All",
      isBaseCity: false, cityNameOriginal: "All", isSubContractorCity: false
    }
    this.cityListForJobPlanning.push(objAll);
    this.spinnerService.show();
    this.jobLaborService.getAllCityListForAssignedUser().subscribe({
      next: (response: cityListForJobPlanningWithDate) => {
        if (this.commonService.isNotNULLEmptyUndefind(response)) {
          this.todaysDate = moment(response.currentDate).format("YYYY-MM-DD");
          response.cityList = response.cityList.filter(r => r.isBaseCity);
          response.cityList.forEach(element => {
            this.cityListForJobPlanning.push(element);
          });
          let isExistDefaultCity = this.cityListForJobPlanning.filter(r => r.isDefaultCity === true);
          if (this.commonService.isNotNULLEmptyUndefindArray(isExistDefaultCity)) {
            if (localStorage.getItem('roleKey') === ROLE_CONSTANTS.CITY_MANAGER ||
              localStorage.getItem('roleKey') === ROLE_CONSTANTS.ASSISTANT_CITY_MANAGER) {
              this.selectedCityValue.setValue(isExistDefaultCity[0]);
            } else {
              this.selectedCityValue.setValue(this.cityListForJobPlanning[0]);
            }
          } else {
            this.selectedCityValue.setValue(this.cityListForJobPlanning[0]);
          }
        }
        this.isFirstTime = false;
        this.spinnerService.hide();
        this.refreshDashboardData();
      },
      error: (error) => {
        this.spinnerService.hide();
        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, error?.message);
        }
      }
    });
  }
  goTodaysTileView() {
    if (this.selectedCityValue.value.cityId === "All") {
      this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.WARNING, MESSAGE_CATEGORY_CONSTATNS.JOB_PLANNING, MESSAGE_CONSTATNS.SELECT_CITY);
    } else {
      let url = "job-planning/tile-view/" + this.selectedCityValue.value.cityId + "/" + this.todaysDate;
      this.router.navigate([]).then(result => { window.open(url, '_blank'); });
    }
  }
  getImportantJobUpdates() {
    this.importantJobCardLoading = true;
    this.importantJobUpdateInfo = {} as importantJobUpdatesInfo;
    this.jobLaborService.getImportantJobUpdates(this.selectedCityValue.value.cityId).subscribe({
      next: (response: importantJobUpdatesInfo) => {
        this.importantJobUpdateInfo = response;
      },
      complete: () => {
        setTimeout(() => {
          this.importantJobCardLoading = false;
          this.cdr.markForCheck();
        });
      },
      error: (error) => {
        this.importantJobCardLoading = false;

        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.JOB_PLANNING, error?.message);
        }
      }
    });
  }
  importantJobUpdatesClear() {
    this.spinnerService.show();
    this.jobLaborService.importantJobUpdatesClear().subscribe({
      next: (response: ApiResponse) => {
        this.spinnerService.hide();
        this.commonToastService.showToasterMessage(response.msgCategoryKey, response.msgCategoryTitle, response.message);
        this.refreshDashboardData();
      },
      error: (error) => {
        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.JOB_PLANNING, error?.message);
        }
      }
    });
  }
  openPreviewSO(serviceOrderId: string) {
    let url = "so/view/" + serviceOrderId;
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }

}


